export default "__VITE_ASSET__cb87b470__"